import type { ReactNode } from 'react'

import { Card, CardContent } from '@/components/ui/card'

type AffinityChartEmptyStateProps = {
  actions?: ReactNode
  description: string
  eyebrow: string
  title: string
}

export function AffinityChartEmptyState({
  actions,
  description,
  eyebrow,
  title,
}: AffinityChartEmptyStateProps) {
  return (
    <Card className="border-dashed border-white/80 bg-white/55">
      <CardContent className="space-y-5 px-6 py-10">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-muted-foreground">
            {eyebrow}
          </p>
          <h2 className="text-3xl text-foreground">{title}</h2>
        </div>
        <p className="max-w-3xl leading-7 text-muted-foreground">{description}</p>
        {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
      </CardContent>
    </Card>
  )
}
